import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { LOCAL_STORAGE_KEYS } from '@constants/storage.constants';
import { RoleHelper } from '@helpers/role.helper';
import { UserService } from '@services/user.service';

type AuthMode = 'guestOnly' | 'requireAuth' | 'requireUser';

function getAuthMode(route: ActivatedRouteSnapshot): AuthMode {
  return (route.data['authMode'] as AuthMode | undefined) ?? 'requireAuth';
}

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): boolean | UrlTree => {
  const router = inject(Router);
  const userService = inject(UserService);

  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
  const isTemporary = RoleHelper.isTemporary();
  const isAuthenticated = !!token || isTemporary;

  const mode = getAuthMode(route);

  if (mode === 'guestOnly') {
    if (isTemporary) {
      return true;
    }
    if (isAuthenticated) {
      return router.createUrlTree(['home']);
    }
    return true;
  }

  if (mode === 'requireUser') {
    if (!isAuthenticated) {
      return router.createUrlTree(['/']);
    }

    const user = userService.getUser();
    if (user && Object.keys(user).length > 0) {
      return true;
    }

    return router.createUrlTree(['/']);
  }

  if (mode === 'requireAuth') {
    if (isAuthenticated) {
      return true;
    }
    return router.createUrlTree(['/']);
  }

  return true;
};
